export default __webpack_public_path__ + "static/media/busho.c196b91d.svg";